import PropTypes from 'prop-types';

import doctorsStrings from 'modules/doctors/strings';

import { Wrapper, SearchBarWrapper, SearchBar, SearchBarIcon } from './DoctorsFilter.style';

const DoctorsFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={doctorsStrings.doctorsFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);
DoctorsFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default DoctorsFilter;
